import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { focusRingClassName, useReducedMotion } from '@digiwedge/ui-headless';
import { colors } from '../../theme/colors.js';
export const Button = ({ children, fullWidth = false, hoverColor, htmlType, icon, loading = false, shape, size = 'middle', variant = 'primary', className, disabled, ...props }) => {
    const prefersReducedMotion = useReducedMotion();
    const isDisabled = Boolean(disabled) || loading;
    const lightenColor = (color, amount = 20) => {
        const hex = color.replace('#', '');
        const r = Math.min(255, parseInt(hex.substring(0, 2), 16) + amount);
        const g = Math.min(255, parseInt(hex.substring(2, 4), 16) + amount);
        const b = Math.min(255, parseInt(hex.substring(4, 6), 16) + amount);
        return `#${r.toString(16).padStart(2, '0')}${g
            .toString(16)
            .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };
    const defaultHoverColor = lightenColor(colors.primary);
    const classes = [
        `rounded-md text-[15px] transition-all duration-[var(--animation-duration,150ms)] flex items-center justify-center ${focusRingClassName}`,
        variant === 'secondary'
            ? 'bg-white border border-primary text-primary'
            : variant === 'text'
                ? 'bg-transparent border-none text-primary p-0'
                : 'bg-primary border-none text-white',
    ];
    if (shape === 'circle') {
        classes.push('p-0 w-8 h-8 rounded-full');
    }
    else if (shape === 'round') {
        classes.push('rounded-full');
    }
    if (size === 'small') {
        classes.push('px-2 py-1 text-sm');
    }
    else if (size === 'large') {
        classes.push('px-6 py-3 text-lg');
    }
    else {
        classes.push('px-4 py-2');
    }
    if (className) {
        classes.push(className);
    }
    if (fullWidth) {
        classes.push('w-full');
    }
    if (isDisabled) {
        classes.push('cursor-not-allowed opacity-60');
    }
    return (_jsxs("button", { type: htmlType, className: classes.join(' '), disabled: isDisabled, "aria-busy": loading || undefined, onMouseEnter: (e) => {
            if (variant === 'primary' && !isDisabled) {
                e.currentTarget.style.backgroundColor = hoverColor || defaultHoverColor;
            }
        }, onMouseLeave: (e) => {
            if (variant === 'primary' && !isDisabled) {
                e.currentTarget.style.backgroundColor = colors.primary;
            }
        }, ...props, children: [loading && (_jsxs("svg", { className: `mr-2 h-4 w-4${prefersReducedMotion ? '' : ' animate-spin'}`, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" })] })), icon && !shape && !loading && _jsx("span", { className: "mr-2", children: icon }), icon && shape ? icon : children] }));
};
//# sourceMappingURL=Button.js.map